// extracted by mini-css-extract-plugin
module.exports = {"list":"index-module--list--31L8s","item":"index-module--item--17pfD","img":"index-module--img--2cCGE"};